import { UserBranchAccessStatus } from "@/features/auth/model/auth-types"
import { type WorkspaceInvitation, type WorkspaceTeamMember } from "@/features/users/model"
import { InvitationListStatus } from "@/features/users/model/team-panel"

/**
 * The people who belong to a branch's team: an ACTIVE dashboard access on that branch. The same rule the team
 * list applies (`UsersListContainer`), so the count in the identity card and the tab pill match the list.
 */
export function selectBranchTeamMembers(
  members: readonly WorkspaceTeamMember[],
  branchId: string | null | undefined,
): WorkspaceTeamMember[] {
  if (!branchId) return [...members]
  return members.filter((member) =>
    (member.userBranchAccesses ?? []).some(
      (access) => access.branchId === branchId && access.status === UserBranchAccessStatus.ACTIVE,
    ),
  )
}

/** Invitations still waiting for an answer (system invites excluded), narrowed to a branch when scoped. */
export function selectPendingInvitations(
  invitations: readonly WorkspaceInvitation[],
  branchId: string | null | undefined,
): WorkspaceInvitation[] {
  return invitations.filter(
    (invitation) =>
      !invitation.isSystemInvite
      && invitation.status.trim().toLowerCase() === InvitationListStatus.Pending
      && (!branchId || invitation.branchId === branchId),
  )
}

/** "Prénom Nom", the linked member's name, or the fallback. */
export function teamMemberDisplayName(member: WorkspaceTeamMember, fallback: string): string {
  const fullName = `${member.firstName} ${member.lastName}`.trim()
  if (fullName.length > 0) return fullName
  if (member.member) {
    const memberName = `${member.member.firstName} ${member.member.lastName}`.trim()
    if (memberName.length > 0) return memberName
  }
  return fallback
}
